/* eslint-disable max-len */
import React from 'react';
import moment from 'moment';

function ActivityLog({ activityLogDetails }) {
    return (
        <div className="p-2.5 border-2 border-[#E9EDF4] bg-[#ffffff] rounded-lg">
            <p className="text-f3 font-semibold text-[#000000] pb-1.5 pl-[11px]">Activity Log</p>
            <div className="max-h-[250px] overflow-auto custom-scrollbar-gray pl-[11px]">
                <div className="pr-2">
                    {activityLogDetails.length > 0 && activityLogDetails.map((item) => (
                        <div className="flex items-start pb-[18px] border-b-[1.5px] border-[#E9EDF4] pt-3.5">
                            <div className="w-[20%]">
                                <div>
                                    <p className="text-sm44 font-semibold text-[#090406] break-words">{item?.updated_by}</p>
                                    <p className="text-sm42 font-semibold text-[#808285]">{moment.unix(item?.updated_at).format('DD-MMM-YYYY, HH:mm:ss')}</p>
                                </div>
                            </div>
                            <div className="w-[80%] pl-2.5">
                                <p>
                                    {item?.log}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ActivityLog;
